module.exports = __webpack_public_path__ + "media/img/pages/profile/aldi ger 5-a58a613e216db0029bcce5fe96ec3c59.jpg";